module.exports = __webpack_public_path__ + "img/devices.8af6a45d.svg";